import { FormValidator, ValidationRules } from 'src/utils/FormValidator';
import { Tag, TagValue } from '../types/helios/Tags';
import { normalizeForComparison } from '../utils/stringUtils';

export const DUPLICATE_TAG_VALUE_ERROR =
  'Value already exists (case-insensitive match found)';

export const TagFormValidator = (isEditMode: boolean = false): FormValidator => {
  const validator = new FormValidator();

  // Only validate tagGroupName in create mode (it's read-only in edit mode)
  if (!isEditMode) {
    validator.addRule(
      'tagGroupName',
      ValidationRules.required,
      'Error: Tag Group Name is required',
    );
  }
  validator.addRule(
    'businessUnitId',
    ValidationRules.required,
    'Error: Please select Business Unit',
  );
  // Description is now optional - no validation needed
  validator.addRule(
    'values',
    (values: any) => {
      if (!values || Object.keys(values).length === 0) {
        return false;
      }
      // Tag values exist, validation passes
      return true;
    },
    'Error: Please add at least one Tag Value for this Tag Group',
  );

  validator.addRule(
    'values',
    (values: any) => {
      if (!values || Object.keys(values).length === 0) {
        return true; // No values to check for duplicates
      }
      // Check for case-insensitive duplicates (with normalized values)
      const keys = Object.keys(values);
      const normalizedKeys = keys.map((key) => normalizeForComparison(key));
      const uniqueKeys = new Set(normalizedKeys);
      return uniqueKeys.size === normalizedKeys.length;
    },
    DUPLICATE_TAG_VALUE_ERROR,
  );

  return validator;
};
